/** Rich detail wins only for members in the current compact roster.
 * Missing optional fields retain compact values; an empty roster stays empty. */
export function projectStaffRoster<T extends { id: string }>(compact: T[] | undefined, detail: T[] | undefined, previous: T[]): T[] {
  if (compact === undefined) return detail ?? previous;
  if (detail === undefined) return compact;
  const byId = new Map(detail.map(m => [m.id, m]));
  return compact.map(m => ({ ...m, ...byId.get(m.id) }));
}

/** Costs must come from the current detail, never an old/mock or guessed wage.
 * Ignore duty strings: they need a separate mechanical audit. */
export function projectStaffHireCosts(catalog: Array<{role: string; wagePerDayCents: number}> | undefined): Array<{role: string; wagePerDayCents: number}> {
  return (catalog ?? []).filter(r => Number.isSafeInteger(r.wagePerDayCents) && r.wagePerDayCents >= 0)
    .map(({role, wagePerDayCents}) => ({role, wagePerDayCents}));
}

/** A previously selected destination disappearing must not redirect work. */
export function staffDeployTarget<T extends {id: string}>(enclosures: T[], selectedId: string | null): T | undefined {
  return selectedId === null ? enclosures.at(0) : enclosures.find(e => e.id === selectedId);
}
